import { backendApiCall } from "../../../../../../helper";

export const fetchProductCatalog = async () => {
  const res = await backendApiCall({ endpoint: `settings/taxonomies` });
  console.log(res.response.data);
  return res.response.data;
};
